var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('d2-page-cover',{attrs:{"title":"插件演示","sub-title":"D2Admin 集成了许多实用插件"}},[_c('img',{attrs:{"src":require("./image/icon.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }